angular.module('gym').factory('DashboardPrivacyModeService', ["CwStorage", function(CwStorage) {
  return {
    isEnabled: function() {
      return JSON.parse(CwStorage.getItem('DashboardPrivacyModeEnabled'));
    },
    set: function(value) {
      CwStorage.setItem('DashboardPrivacyModeEnabled', value);
      return CwStorage.removeItem('HideDashboardPrivacyModeBar');
    },
    hideBar: function() {
      return CwStorage.setItem('HideDashboardPrivacyModeBar', true);
    },
    isBarVisible: function() {
      return !JSON.parse(CwStorage.getItem('HideDashboardPrivacyModeBar'));
    }
  };
}]);
